import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";

const Spacer = styled.div<SpaceProps>`
    ${space};
`;

export default Spacer;
